(function (app) {

    app.provider("fillableFormApi",
    [
        function() {
            this.$get = [
                "complianceHubApiGateway", function(complianceHubApiGateway) {
                    var service = {};

                    //GETs
                    service.get = function(fillableFormId) {
                        return complianceHubApiGateway.getFile("/FillableForms/" + fillableFormId, { headers: { "Accept": "application/pdf" } });
                    };

                    service.getFillableForms = function() {
                        return complianceHubApiGateway.getArray("/FillableForms");
                    };

                    service.getTransactionGroupForms = function(transactionGroupId) {
                        return complianceHubApiGateway.getArray("/TransactionGroups/" + transactionGroupId + "/FillableForms");
                    };

                    service.getTransactionForms = function(transactionId) {
                        return complianceHubApiGateway.getArray("/Transactions/" + transactionId + "/FillableForms");
                    };

                    service.getTransactionForm = function(transactionId, fillableFormId) {
                        return complianceHubApiGateway.getFile("/Transactions/" + transactionId + "/FillableForms/" + fillableFormId, { headers: {"Accept": "application/pdf"} });
                    };

                    //PUTs
                    service.update = function(fillableFormId, form) {
                        return complianceHubApiGateway.put("/FillableForms/" + fillableFormId, form);
                    };

                    service.complete = function(fillableFormId, form) {
                        return complianceHubApiGateway.put("/FillableForms/" + fillableFormId + "/Complete", form);
                    };

                    //POSTs
                    service.add = function(transactionGroupId, file) {
                        return complianceHubApiGateway.postFile("/TransactionGroups/" + transactionGroupId + "/FillableForms",  file);
                    };

                    //DELETEs
                    service.delete = function(fillableFormId) {
                        return complianceHubApiGateway.delete("/FillableForms/" + fillableFormId);
                    };

                    return service;
                }
            ];
        }
    ]);

})(window.app); //jshint ignore:line